import { useEffect, useState } from "react";

import { useWebRTC } from "providers/WebRTCProvider";

import FunctionalButton from "components/layout/FunctionalButton";

import { StreamingState } from "lib/consts/streaming";

const StreamingSourceButton = ({ className = "", onClick }) => {
    const { connectedToWebRTC, streamStatuses, activeStream, showStreamingSource, setShowStreamingSource } =
        useWebRTC();

    const [streamStatusClassName, setStreamStatusClassName] = useState("bg-warning");

    useEffect(() => {
        if (!connectedToWebRTC) return setStreamStatusClassName("bg-warning");

        // Update status color based on active stream
        if (activeStream) {
            let status = streamStatuses.get(activeStream);
            switch (status) {
                case StreamingState.Okay:
                    setStreamStatusClassName("bg-primary2");
                    break;

                case StreamingState.Slow:
                case StreamingState.Reconnecting:
                    setStreamStatusClassName("bg-yellow-500");
                    break;

                default:
                    setStreamStatusClassName("bg-warning");
                    break;
            }
        }
    }, [connectedToWebRTC, streamStatuses, activeStream]);

    const handleClick = () => {
        if (onClick) {
            onClick(); // Call parent onClick if provided
        } else {
            setShowStreamingSource(!showStreamingSource);
        }
    };

    return (
        <FunctionalButton
            className={`control-button-type3 ${streamStatusClassName} ${className}`}
            title={activeStream || "No Stream"}
            onClick={handleClick}
        />
    );
};

export default StreamingSourceButton;
